import { TARGETS, XDMWrapper } from '@gt-common/event-logger-web';
import { BaseSchemaCabs, BaseCabsEvent } from './xdmSchema';
import { keysToGenerate } from './adobeKeyConfig'
import { fetchSeoXdmPayload } from './seoXdmApi';

export const analyticsSDK = XDMWrapper.initAndSetAnalyticsSdk({
  org: 'GI',
});

export const logEventToXDMWithPage = async (): Promise<void> => {
  try {
    const xdmPayload = await fetchSeoXdmPayload();
    if(xdmPayload){
      xdmPayload.event_tracking_context.session_id = await analyticsSDK.getSessionId();
      logEventToXDM(xdmPayload);
    }
  } catch (error) {
    console.warn('Error while logging XDM', error);
  }
};

export const logEventToXDM = (eventLogger: BaseCabsEvent) => {
  try {
    _logEventToXDM(eventLogger);
  } catch (e) {
    console.log('Error while XDM logging', e);
  }
};

const _logEventToXDM = async (eventLogger: BaseCabsEvent) => {
  XDMWrapper.logEvent({
    payload: eventLogger,
    otherConfig: {
      lobName: 'cabs',
      adobeKeyConfig: keysToGenerate,
    },
    target: TARGETS.ALL,
    extraOptions: {
      lob: 'cabs',
      destinationUrl: typeof window !== 'undefined' ? window.location.href : '',
    },
    schema: BaseSchemaCabs,
  });
};
